// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import { Modal, Input, notification } from 'antd';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../constants/api';

const DeleteModal = ({
  userId,
  token,
  table,
  id,
  modalVisible,
  setModalVisible,
}) => {
  const [loading, setLoading] = useState(false);

  const [reason, setReason] = useState('');
  const [password, setPassword] = useState('');

  // Function to confirm deletion and send API request
  const handleOk = () => {
    if (reason.trim() === '') {
      notification.error({ message: 'Reason is required!' });
      return;
    }
    deleteRecord(id); // Call delete record API
    setModalVisible(false); // Close the modal
  };

  const handleCancel = () => {
    setModalVisible(false); // Close the modal without deleting
  };

  // Separate function to handle input change
  const handleReasonInputChange = (e) => {
    const value = e.target.value; // Get the current value of the input
    setReason(value); // Update the state with the new value
    // console.log('Updated reason:', value); // Log the updated value
    // console.log('reason state: ', reason);
  };
  // Separate function to handle input change
  const handlePasswordInputChange = (e) => {
    const value = e.target.value; // Get the current value of the input
    setPassword(value); // Update the state with the new value
    // console.log('Updated reason:', value); // Log the updated value
    // console.log('reason state: ', reason);
  };

  // Function to delete record by ID
  const deleteRecord = async (id) => {
    setLoading(true);
    const deleteData = {
      reason: reason,
      password: password,
    };
    const deleteUrl = `${API_URL}/${ENDPOINTS.SYS}/delete/${table}/${id}`;
    // console.log('url:', deleteUrl, 'deleteData:', deleteData);
    try {
      const response = await axios.delete(deleteUrl, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
        data: deleteData,
      });

      // onRequestClose(); // Close modal after submission
      if (response.data.success === 0) {
        notification.error({ message: response.data.message });
      } else {
        notification.success({ message: 'Record deleted successfully!' });
      }
    } catch (error) {
      alert('An error occurred ');
      notification.error({ message: 'An error occurred ' + error.message });

      // console.log('error:', error, 'updateUrl:',updateUrl, 'updatValues:', updateValues);
    }
  };

  //console.log('columns:', columns);

  return (
    <Modal
      getContainer={false} // Renders at the top level
      title="Are you sure you want to delete this record?"
      visible={modalVisible} // Control visibility via state
      onOk={handleOk} // Call handleOk function on confirm
      onCancel={handleCancel} // Call handleCancel function on cancel
    >
      <p>Please provide a reason for deleting this record:</p>
      <Input
        placeholder="Enter reason"
        onChange={handleReasonInputChange} // Update state on input change
        value={reason} // Bind input value to state
      />
      <Input
        type="password" // Set type to password for hidden characters
        placeholder="Enter Password"
        onChange={handlePasswordInputChange} // Update state on input change
        value={password} // Bind input value to state
      />
    </Modal>
  );
};

export default DeleteModal;
